/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {HISTORY_EVENT_ICON_BY_ASSET} from '../maps/constants';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Stop Icon component.
 */
export const StopIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  const {stop}     = HISTORY_EVENT_ICON_BY_ASSET;

  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M8 0C3.58172 -3.86257e-07 3.86258e-07 3.58172 0 8C-3.86258e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 3.86259e-07 8 0ZM11.5624 5.93785C11.8661 5.63419 11.8661 5.14186 11.5624 4.8382C11.2588 4.53454 10.7664 4.53454 10.4628 4.8382L8.20061 7.10035L5.93842 4.83816C5.63476 4.5345 5.14243 4.5345 4.83877 4.83816C4.53511 5.14182 4.53511 5.63415 4.83877 5.93781L7.10096 8.2L4.83877 10.4622C4.53511 10.7658 4.53511 11.2582 4.83877 11.5618C5.14243 11.8655 5.63476 11.8655 5.93842 11.5618L8.20061 9.29965L10.4628 11.5618C10.7664 11.8655 11.2588 11.8655 11.5624 11.5618C11.8661 11.2581 11.8661 10.7658 11.5624 10.4622L9.30026 8.2L11.5624 5.93785Z'
        fill={stop.color} />
    </svg>
  );
};
